<div class="modal-header">
  <h4 class="modal-title">Chatbot Manuals</h4>
  <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
    <img src="assets/icons/close-icon.svg" alt="close">
  </button>
</div>

<div class="modal-body">
  <div class="search-wrap">
    <img src="assets/icons/search-icon.svg" alt="Search" class="search-icon">
    <input
      type="text"
      class="search-input"
      placeholder="Search by module or document name..."
      [(ngModel)]="searchTerm">
  </div>

  <div class="table-wrap" *ngIf="!isLoading">
    <table class="manual-table">
      <thead>
        <tr>
          <th>Module</th>
          <th>Document Name</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of filteredRows">
          <td>{{ row.category }}</td>
          <td>{{ row.documentName }}</td>
          <td class="actions-cell">
            <div class="actions-wrap">
              <button class="icon-action" (click)="onPreview(row)" title="Preview" aria-label="Preview document">
                <img src="assets/icons/show-eye.svg" alt="Preview">
              </button>
              <button class="icon-action" (click)="onDownload(row)" title="Download" aria-label="Download document">
                <img src="assets/icons/download-button.svg" alt="Download">
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="filteredRows.length === 0">
          <td colspan="3" class="empty-row">No documents found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="loading" *ngIf="isLoading">Loading documents...</div>
</div>
